import { ProjectResponse } from '../../models/projects/ProjectResponse';
import { AccountResponse } from '../../models/account/AccountResponse';
import { MonitorPrompt } from '../../models/monitor/MonitorPrompt';
import { ChartMatrixData } from '../../../pages/prompt/preview/components/stats/models/StatsModel';

export const getProjectsFromAccount = (
  accountResponse: AccountResponse | null,
  projects: ProjectResponse[]
): ProjectResponse[] => {
  if (!accountResponse) {
    return projects;
  }

  if (accountResponse.isLimitedSuperAdmin) {
    return projects.filter((project) => project.accountId === accountResponse.accountId);
  }

  return projects;
};

export const hasWaitingPrompts = (monitorPrompts: MonitorPrompt[]) => {
  if (!monitorPrompts) {
    return false;
  }

  return monitorPrompts.some((prompt) => ['PENDING', 'REFRESHING'].includes(prompt.status));
};

export const hasProjectStats = (projectStatsMatrix: ChartMatrixData | null): boolean => {
  if (!projectStatsMatrix) {
    return false;
  }

  return Boolean(
    projectStatsMatrix.matrix.length > 1 ||
      (projectStatsMatrix.secondMatrix && projectStatsMatrix.secondMatrix.length > 1)
  );
};

export const getCurrentProject = (projectResponse: ProjectResponse[], currentProjectId: number) =>
  projectResponse.find((project) => project.id === currentProjectId);

export const formatSearchVolume = (volume: number | null | undefined): string => {
  if (!volume) {
    return '<100';
  }

  return volume > 100 ? Intl.NumberFormat('pl-PL').format(volume) : '<100';
};
